import React from 'react';

const MiniBar = ({ percent, colorClass }) => (
  <div className="w-20 h-1.5 bg-slate-100 rounded-full overflow-hidden">
    <div className={`h-full rounded-full ${colorClass}`} style={{ width: `${Math.min(percent, 100)}%` }} />
  </div>
);

export default MiniBar;